
import React, { useState } from "react";
import PropTypes from 'prop-types';
import renderModal from '@components/show_page/modals/renderModal';

function ManageLabelModal(props) {
  const [labelName, updateName] = useState(props.activeLabel.name);

  const updateLabel = () => {
    const { editLabel, activeLabel } = props;
    const newLabelData = { name: labelName };
    editLabel(activeLabel.key, newLabelData);
  };

  const deleteLabel = () => {
    const { removeLabel, activeLabel } = props;
    removeLabel(activeLabel.key, activeLabel.name);
  };

  const submitIfEnter = (e) => {
    if (e.key === 'Enter') {
      updateLabel();
    }
  };

  return (
    <div className="modal-content-wrapper manage-labels-modal">
      <div className="modal-content-wrapper__header">
        <span className="bff-label icon" aria-hidden="true" />
        <h3 className="modal-title">{t("Edit Label")}</h3>
      </div>
      <div className="modal-content-wrapper__body">
        <h3 className="body-title">
          {props.activeLabel.name}
        </h3>
        <label htmlFor="name">
          {t('Name')}:
          <input
            className="input form-html-label"
            type="text"
            name="name"
            value={labelName}
            onChange={(e) => updateName(e.target.value)}
            onKeyPress={submitIfEnter}
            autoFocus
          />
        </label>
        <div className="button-container ">
          <button
            className="delete-button"
            onClick={deleteLabel}
            type="button"
          >
            <span className="bff-trash" />
            {t('Delete')}
          </button>
          <div>
            <button
              className="button tertiary sm t-close-modal"
              onClick={() => props.toggleModal()}
              type="button"
            >
              {t('Close')}
            </button>
            <button
              className="button primary sm t-save"
              onClick={updateLabel}
              type="button"
              disabled={props.activeLabel.name === labelName}
            >
              {t('Save')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

ManageLabelModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  removeLabel: PropTypes.func.isRequired,
  editLabel: PropTypes.func.isRequired,
  activeLabel: PropTypes.shape({
    actionType: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string
  }).isRequired
};

const ModalComponent = renderModal(ManageLabelModal, 'ManageLabelModal');
export default ModalComponent;
